import React, { useEffect, useMemo, useState } from 'react';
import { useSelector } from 'react-redux';
import ProductTilesListContext from '@stone/scripts/contexts/ProductTilesListContext';
import ProductTile from '@stone/components/product/ProductTile';
import ProductTilesRail from '@stone/components/product/ProductTilesRail';
import ProductEditorialRail from '@stone/components/listing/ProductEditorialRail';
import { generateListName } from '@stone/utils/analytics';
const getFiltersCount = (selectedFilters) => {
    return selectedFilters === null || selectedFilters === void 0 ? void 0 : selectedFilters.reduce((count, filter) => {
        var _a;
        return count + (((_a = filter === null || filter === void 0 ? void 0 : filter.values) === null || _a === void 0 ? void 0 : _a.length) || 0);
    }, 0);
};
const returnIndexedProducts = (products) => {
    return products.map((product, index) => {
        return Object.assign(Object.assign({}, product), { analyticsIndex: index });
    });
};
const Rail = ({ type, children }) => {
    return (React.createElement("li", { className: `full-grid rail--${type}` },
        React.createElement("div", { className: "align-container" }, children)));
};
const TierBlock = (props) => {
    var _a, _b;
    const { productSort, category, selectedFilters, breadcrumbs } = useSelector((state) => state.search);
    const selectedFiltersCount = useMemo(() => {
        return getFiltersCount(selectedFilters);
    }, [selectedFilters]);
    // notihing to render
    const listContext = useMemo(() => {
        let context = {};
        if (category) {
            context.analyticsData = {
                item_list_name: generateListName({
                    breadcrumb: breadcrumbs,
                    pageCategory: 'plp',
                }),
            };
        }
        return context;
    }, [category]);
    if (((_a = props.listing) === null || _a === void 0 ? void 0 : _a.length) < 1)
        return React.createElement(React.Fragment, null);
    switch (props.type) {
        case 'CONTENT':
            return (
            //not display content when filters applied
            !selectedFiltersCount &&
                (productSort === null || productSort === void 0 ? void 0 : productSort.isDefault) &&
                ((_b = props.listing) === null || _b === void 0 ? void 0 : _b.map((editorialItem, i) => {
                    let componentProps = Object.assign({}, editorialItem);
                    delete componentProps.typeid;
                    return (React.createElement(Rail, { type: props.type, key: i },
                        React.createElement(ProductEditorialRail, { typeid: editorialItem.typeid, componentProps: componentProps })));
                })));
        case 'EDITORIALTILE':
            return (React.createElement(Rail, { type: props.type },
                React.createElement(ProductTilesRail, { tileType: "PLP", analyticsName: listContext.analyticsData.item_list_name, pageType: props.pageType, railType: "EDITORIALTILE", productTiles: props.listing })));
        case 'UNTILPAGINATIONEND':
            return (React.createElement(ProductTilesListContext.Provider, { value: listContext }, props.listing.map((tile, i) => {
                var _a;
                return (React.createElement(React.Fragment, { key: tile.id },
                    React.createElement("li", null,
                        React.createElement(ProductTile, { index: 16 + i, product: tile, type: 'PLP', pageType: props.pageType, headingLevel: 'h2', category: category, sortingrule: productSort === null || productSort === void 0 ? void 0 : productSort.ruleId })),
                    ((_a = props.contents) === null || _a === void 0 ? void 0 : _a.length) > 0 && (i + 1) % 8 === 0 && React.createElement(TierBlock, { type: "CONTENT", listing: props.contents.splice(0, 1) })));
            })));
    }
    return (React.createElement(ProductTilesListContext.Provider, { value: listContext }, props.listing.map((tile, i) => (React.createElement("li", { key: tile.id },
        React.createElement(ProductTile, { pageType: props.pageType, index: props.startIndex + i, product: tile, type: 'PLP', headingLevel: 'h2', category: category, sortingrule: productSort === null || productSort === void 0 ? void 0 : productSort.ruleId }))))));
};
const TierOne = ({ pageType }) => {
    const { results, editorialcards } = useSelector((state) => state.search);
    const content = editorialcards ? [...editorialcards] : [];
    const items = [...returnIndexedProducts(results)];
    return (React.createElement(React.Fragment, null,
        React.createElement(TierBlock, { type: "STANDARD", pageType: pageType, startIndex: 0, listing: items.splice(0, 8) }),
        (items === null || items === void 0 ? void 0 : items.length) > 7 && (content === null || content === void 0 ? void 0 : content.length) > 0 && React.createElement(TierBlock, { type: "CONTENT", startIndex: 0, listing: content.splice(0, 1) }),
        (items === null || items === void 0 ? void 0 : items.length) > 0 && React.createElement(TierBlock, { pageType: pageType, type: "EDITORIALTILE", startIndex: 8, listing: items.splice(0, 9) }),
        (results === null || results === void 0 ? void 0 : results.length) > 16 && (content === null || content === void 0 ? void 0 : content.length) > 0 && React.createElement(TierBlock, { type: "CONTENT", startIndex: 1, listing: content.splice(0, 1) }),
        (items === null || items === void 0 ? void 0 : items.length) > 0 && React.createElement(TierBlock, { type: "UNTILPAGINATIONEND", pageType: pageType, startIndex: 16, listing: items, contents: content })));
};
const TierTwo = ({ pageType }) => {
    const { results, editorialcards } = useSelector((state) => state.search);
    const content = editorialcards ? [...editorialcards] : [];
    const items = [...returnIndexedProducts(results)];
    return (items === null || items === void 0 ? void 0 : items.length) > 0 && React.createElement(TierBlock, { type: "UNTILPAGINATIONEND", pageType: pageType, startIndex: 0, listing: items, contents: content });
};
const TierThree = ({ pageType }) => {
    const { results, editorialcards } = useSelector((state) => state.search);
    const items = [...returnIndexedProducts(results)];
    const [listing, setListing] = useState([]);
    function adjustListingWithEditorials(products, editorials) {
        let adjustedProducts = [...products];
        let sortedEditorials = editorials.sort((a, b) => a.tileindex - b.tileindex);
        let insertedEditorials = 0;
        sortedEditorials.forEach((editorial) => {
            let adjustedIndex = editorial.tileindex - insertedEditorials;
            if (editorial.tileindex - products.length > 1) {
                return;
            }
            if (editorial.type === 'component_plp_editorial_grid') {
                const gridProducts = adjustedProducts.splice(adjustedIndex, 9);
                const editorialWithProducts = Object.assign(Object.assign({}, editorial), { tiles: gridProducts });
                adjustedProducts.splice(adjustedIndex, 0, editorialWithProducts);
                insertedEditorials += 8;
            }
            else {
                adjustedProducts.splice(adjustedIndex, 0, editorial);
            }
        });
        return adjustedProducts;
    }
    useEffect(() => {
        if ((results === null || results === void 0 ? void 0 : results.length) > 0) {
            // let editorials = _.groupBy(content, 'tileIndex');
            let editorials = [...editorialcards];
            const listing = adjustListingWithEditorials(items, editorials);
            setListing(listing);
        }
    }, [results]);
    return (React.createElement(React.Fragment, null, listing.map((item, i) => (React.createElement(TierBlock, { key: item.ID || item.id || i, type: item.type === 'component_plp_editorial_grid' ? 'EDITORIALTILE' : item.type == 'tile' ? 'STANDARD' : 'CONTENT', listing: item.tiles || [item], pageType: pageType })))));
};
const ListingTier = (props) => {
    const { search, loading } = useSelector((state) => state);
    const [loadingChanged, setLoadingChanged] = useState(false);
    const [filtered, setFiltered] = useState(false);
    const selectedFiltersCount = useMemo(() => {
        return getFiltersCount(search.selectedFilters);
    }, [search.selectedFilters]);
    const isLoading = useMemo(() => loading.requests.includes('LISTING'), [loading.requests]);
    useEffect(() => {
        if (isLoading) {
            setLoadingChanged(true);
        }
        if (!isLoading && loadingChanged) {
            setFiltered(!!selectedFiltersCount);
            setLoadingChanged(false);
        }
    }, [selectedFiltersCount, isLoading, loadingChanged]);
    return (React.createElement(React.Fragment, null, (search === null || search === void 0 ? void 0 : search.productSort.isDefault) && !filtered && props.tier ? (React.createElement(React.Fragment, null,
        props.tier === 'tier1' && React.createElement(TierOne, Object.assign({}, props)),
        props.tier === 'tier2' && React.createElement(TierTwo, Object.assign({}, props)),
        props.tier === 'tier3' && React.createElement(TierThree, Object.assign({}, props)))) : (React.createElement(TierTwo, Object.assign({}, props)))));
};
export default ListingTier;
